import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  allocation: Yup.number()
    .min(1, 'Allocation must be between 1 and 100')
    .max(100, 'Allocation must be between 1 and 100')
    .required('Required')
    .typeError('Please enter a valid number'),
});
